import { render, staticRenderFns } from "./lastYear.vue?vue&type=template&id=9d437530&scoped=true&"
import script from "./lastYear.vue?vue&type=script&lang=js&"
export * from "./lastYear.vue?vue&type=script&lang=js&"
import style0 from "./lastYear.vue?vue&type=style&index=0&id=9d437530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d437530",
  null
  
)

export default component.exports